'use client';

import {
  computeTaskSegments,
  getActiveBreakpointIndex,
} from './ui.video-player.helpers';
import { Breakpoint, TaskSegment } from './ui.video-player.types';

interface UseVideoPlayerTaskNavigationArgs {
  showTaskNavigation: boolean;
  breakpoints: Breakpoint[];
  currentTime: number;
  displayTime: number;
  duration: number;
  seekTo: (time: number) => void;
}

// test-exception: pure derivation + onClick handlers; the underlying
// `getActiveBreakpointIndex` and `computeTaskSegments` are covered by
// ui.video-player.helpers.spec.ts. shared-ui has no
// @testing-library/renderHook infrastructure.
export const useVideoPlayerTaskNavigation = ({
  showTaskNavigation,
  breakpoints,
  currentTime,
  displayTime,
  duration,
  seekTo,
}: UseVideoPlayerTaskNavigationArgs) => {
  const showTaskNav = showTaskNavigation && breakpoints.length > 0;

  const activeBreakpointIndex = getActiveBreakpointIndex(
    currentTime,
    breakpoints
  );

  const isPrevTaskDisabled = activeBreakpointIndex <= 0;
  const isNextTaskDisabled = activeBreakpointIndex >= breakpoints.length - 1;
  const taskNumber = Math.max(activeBreakpointIndex, 0) + 1;

  const handlePrevTask = () => {
    if (isPrevTaskDisabled) return;
    seekTo(breakpoints[activeBreakpointIndex - 1].time);
  };

  const handleNextTask = () => {
    if (isNextTaskDisabled) return;
    seekTo(breakpoints[activeBreakpointIndex + 1].time);
  };

  const taskSegments: TaskSegment[] = showTaskNav
    ? computeTaskSegments(breakpoints, duration, displayTime)
    : [];

  return {
    showTaskNav,
    activeBreakpointIndex,
    isPrevTaskDisabled,
    isNextTaskDisabled,
    taskNumber,
    handlePrevTask,
    handleNextTask,
    taskSegments,
  };
};
